import { handleApiAction } from "utils/actions";
import { apiClient } from "utils/clients";
import externals from "utils/externals";
import { getLocalizedValue as t } from "../../../i18n";
import { connectors as i18nNamespace } from "../../../i18n/namespace";

export default ({ dispatch }) => next => action => {
    const { type, payload } = action;

    if (type === "CONNECTORS:GET-OVA-INFO") {
        return handleApiAction(action, () => {
            const PRIVATE_OVA = 'PRIVATE_OVA';
            const STANDARD_RESTRICTED_OVA = 'STANDARD_RESTRICTED_OVA';

            const queryParams = {
                filter: `state eq 'ACTIVE' and releaseType eq '${process.env.REACT_APP_IS_DARK === 'true' ? PRIVATE_OVA : STANDARD_RESTRICTED_OVA}'`
            }
            return apiClient.get(`${externals.gradualDeployBackend}/agent/releases`, { params: queryParams });
        }).catch(e => {
            dispatch({
                type: "NOTIFICATIONS:ERROR",
                payload: {
                    message: t("failed_to_get_ova_info", i18nNamespace),
                    exception: e,
                    group: "DEPLOY-AGENT"
                }
            });
            throw e;
        });
    } else if (type === "CONNECTORS:GENERATE-OVA-URL") {
        return handleApiAction(action, () => {
            let headers = {};
            headers['x-organization-id'] = payload.orgId;
            return apiClient.patch(`${externals.gradualDeployBackend}/agent/releases/${payload.info['id']}`, { stateDesired: 'SIGN_URL'}, { headers});
        }).catch(e => {
            dispatch({
                type: "NOTIFICATIONS:ERROR",
                payload: {
                    message: t("failed_to_generate_ova_url", i18nNamespace),
                    exception: e,
                    group: "DEPLOY-AGENT"
                }
            });
            throw e;
        });
    }

    return next(action);
};
